import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { GuideSidebar } from './GuideSidebar';
import { GuideMobileMenu } from './GuideMobileMenu';
import { GuideSearch } from './search/GuideSearch';
export function GuideShell() {
  const {
    pathname
  } = useLocation();
  const isHome = pathname.replace(/\/$/, '') === '/guia';
  return <main className="pt-20 md:pt-32 pb-24 md:pb-28" data-id="element-473" data-mp="ngwxicqvipvq">
      <div className="max-w-7xl mx-auto grid gap-10 px-5 sm:px-6 lg:grid-cols-[250px_minmax(0,1fr)] lg:px-8 xl:gap-14" data-id="element-474" data-mp="8tbueiu00qnt">
        <aside className="hidden lg:block" data-id="element-475" data-mp="dllped9z0gwy">
          <GuideSidebar data-id="element-476" data-mp="dmet15dmuqav" />
        </aside>
        <div className="min-w-0" data-id="element-477" data-mp="3vzcmctfx6kw2">
          {!isHome && <div className="mb-8" data-id="element-478" data-mp="3vwqgcy8ogdfy">
              <GuideSearch variant="compact" data-id="element-479" data-mp="3tzbg96903qi" />
            </div>}
          <Outlet data-id="element-480" data-mp="3m0ndtr9wycsh" />
        </div>
      </div>
      <GuideMobileMenu data-id="element-481" data-mp="3m1onpsf70t8m" />
    </main>;
}